var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowercase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8972 7.94V14H13.4212V13.028C13.2372 13.364 12.9732 13.628 12.6292 13.82C12.2852 14.004 11.8932 14.096 11.4532 14.096C10.9252 14.096 10.4572 13.968 10.0492 13.712C9.64116 13.456 9.32516 13.092 9.10116 12.62C8.87716 12.148 8.76516 11.6 8.76516 10.976C8.76516 10.352 8.87716 9.8 9.10116 9.32C9.33316 8.832 9.65316 8.456 10.0612 8.192C10.4692 7.92 10.9332 7.784 11.4532 7.784C11.8932 7.784 12.2852 7.88 12.6292 8.072C12.9732 8.256 13.2372 8.516 13.4212 8.852V7.94H14.8972ZM11.8612 12.92C12.3572 12.92 12.7412 12.748 13.0132 12.404C13.2852 12.06 13.4212 11.576 13.4212 10.952C13.4212 10.312 13.2852 9.82 13.0132 9.476C12.7412 9.132 12.3532 8.96 11.8492 8.96C11.3532 8.96 10.9652 9.14 10.6852 9.5C10.4132 9.852 10.2772 10.344 10.2772 10.976C10.2772 11.6 10.4132 12.08 10.6852 12.416C10.9652 12.752 11.3572 12.92 11.8612 12.92Z",
    fill: "#1D6295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowercase);
export default __webpack_public_path__ + "static/media/lowercase.b9d7a01b3b232558481e2213bc482072.svg";
export { ForwardRef as ReactComponent };